// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.agree-detail[data-v-38c226e7] {\n  padding-left: 148px;\n}\n.agree-detail a[data-v-38c226e7] {\n  color: #409eff;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
